import React from 'react';
import Icon from '../../../components/AppIcon';

const DemographicBreakdownTable = ({ data = [] }) => {
  // Show empty state if no data
  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-8 text-center">
        <Icon name="Users" className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">
          No Demographic Data Available
        </h3>
        <p className="text-sm text-muted-foreground">
          Add employees to view departmental staffing breakdowns
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="px-4 md:px-6 py-3 md:py-4 border-b border-border">
        <h3 className="text-base md:text-lg font-semibold text-foreground break-words">
          Departmental Staffing Data Breakdown
        </h3>
        <p className="text-xs md:text-sm text-muted-foreground mt-1 break-words">
          Employee distribution across departments and employment types
        </p>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-3 md:px-6 py-2 md:py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Department
              </th>
              <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Full-Time
              </th>
              <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Casual
              </th>
              <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Fixed-Term
              </th>
              <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Non-Citizen
              </th>
              <th className="px-3 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {data?.map((row, index) => (
              <tr key={index} className="hover:bg-muted/30 transition-colors">
                <td className="px-3 md:px-6 py-3 md:py-4 text-xs md:text-sm font-medium text-foreground break-words max-w-[200px]">
                  {row?.department}
                </td>
                <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-right text-foreground">
                  {row?.fullTime || 0}
                </td>
                <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-right text-foreground">
                  {row?.casual || 0}
                </td>
                <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-right text-foreground">
                  {row?.fixedTerm || 0}
                </td>
                <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-right text-foreground">
                  {row?.nonCitizen || 0}
                </td>
                <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm text-right font-semibold text-foreground">
                  {row?.total || 0}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DemographicBreakdownTable;